"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var getFavoritePersonaByEmail_1 = require("./../../selectors/getFavoritePersonaByEmail");
var isInFavorites_1 = require("./../../selectors/isInFavorites");
var addFavoritePersona_1 = require("./addFavoritePersona");
var removeFavoritePersona_1 = require("./removeFavoritePersona");
var datapoints_1 = require("../../datapoints");
var owa_analytics_1 = require("owa-analytics");
var legacy_1 = require("satcheljs/lib/legacy");
exports.default = legacy_1.action('toggleFavoritePersona', datapoints_1.default.ToggleFavoritePersona)(function toggleFavoritePersona(personaId, emailAddress, displayName, actionSource) {
    if (isInFavorites_1.isPersonaInFavorites(personaId, emailAddress)) {
        if (!personaId) {
            // We are removing favorite from search results header or LPC in which we don't have personaId
            var favoritePersona = getFavoritePersonaByEmail_1.default(emailAddress);
            if (favoritePersona) {
                personaId = getFavoritePersonaByEmail_1.default(emailAddress).id;
            }
            else {
                var _a = datapoints_1.default.RemoveFavoritePersonaFailure.datapoint, eventName = _a.name, customData = _a.customData;
                owa_analytics_1.logUsage(eventName, customData(emailAddress ? 'EmailAddressNotFound' : 'EmailAddressMissing', false));
            }
        }
        return removeFavoritePersona_1.default(personaId, actionSource);
    }
    else {
        return addFavoritePersona_1.default(emailAddress, displayName, personaId, actionSource);
    }
});
//# sourceMappingURL=toggleFavoritePersona.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/data/owa-mail-favorites-store/lib/actions/people/toggleFavoritePersona.js
// module id = 4652
// module chunks = 14